module.exports = __webpack_public_path__ + "static/media/S_S03.76ed8a37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GREEN/S_S03.png
// module id = 111
// module chunks = 0